export default Object.freeze({
    IMAGE: ['image/png', 'image/gif', 'image/jpeg'],
    ZIP: ['application/zip', 'application/octet-stream'],
    JSON: ['application/json'],
});
